module.exports = __webpack_public_path__ + "static/media/action-plan-icon.faabc93b.svg";